export default {"src":"/_next/static/media/Herniated Discs and Spinal Stenosis.df350797.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};